(function () {
  function sendHapticToNative(kind) {

    if (typeof window === 'undefined') {
      console.log('[nativeHaptics] window undefined; skipping dispatch', { kind: kind });
      return;
    }

    var message = JSON.stringify({
      type: 'HAPTIC',
      kind: kind,
    });

    var rnw = window.ReactNativeWebView;

    if (rnw && typeof rnw.postMessage === 'function') {
      console.log('[nativeHaptics] dispatch', { kind: kind, message: message });
      rnw.postMessage(message);
      return;
    }
  }

  window.sendHapticToNative = sendHapticToNative;
})();
